import { ClassConstructor, instanceToPlain, plainToInstance } from 'class-transformer';

export class ClassTransformerHelper {
    static CopyObject<T>(obj: any, type: ClassConstructor<T>): T {
        const json = ClassTransformerHelper.Serialize(obj);
        const copy = ClassTransformerHelper.Deserialize(type, json);
        return copy;
    }

    static Deserialize<T>(type: ClassConstructor<T>, json: string): T {
        return plainToInstance(type, JSON.parse(json));
    }

    static Serialize(obj: any): string {
        return JSON.stringify(instanceToPlain(obj));
    }
}
